import { cpfValidator } from 'helpers/cpfValidator';
import { Dispatch, SetStateAction, useState } from 'react';
import * as yup from 'yup';
import { Patient } from 'types/patient';

export type PatientValidation = {
  document_number?: string;
  rg?: string;
  name?: string;
  email?: string;
  person_type?: string;
};

type UsePatientValidation = [
  PatientValidation,
  Dispatch<SetStateAction<PatientValidation>>,
  (patient: Patient) => Promise<void>,
];

export function usePatientValidation(): UsePatientValidation {
  async function handleValidation(patient: Patient) {
    const schema = yup.object().shape({
      email: yup.string().required('O e-mail é obrigatório').email('O e-mail deve ser válido'),
      rg: yup.string().required('RG é obrigatório'),
      document_number: yup
        .string()
        .transform((value, originalValue) => {
          return originalValue ? originalValue.replace(/\D/g, '') : '';
        })
        .required('O CPF é obrigatório')
        .test('is-valid-cpf', 'CPF inválido', value => {
          if (!value) return false;

          const cpf = cpfValidator(value);

          return cpf;
        }),
      name: yup.string().required('O nome é obrigatório').min(10, 'O nome deve ter no mínimo 10 caracteres'),
    });

    try {
      await schema.validate(patient);
    } catch (err) {
      const error = err as yup.ValidationError;
      if (error.path && error.message) {
        setValidation({
          [error.path]: error.message,
        });
      }
      throw new Error(err as string);
    }
  }

  const [validation, setValidation] = useState<PatientValidation>({});
  return [validation, setValidation, handleValidation];
}
